<div class="form-group">
  <label for="prod-m">{{ 'form.families'| translate }}</label>
  <angular2-multiselect [data]="list"
      [(ngModel)]="familiesSelected"
      [settings]="multiselectSettings[EMULTI_SELECT_SETTING.MULTIPLE_SEARCH]"
      [disabled]="disabled"
      (onSelect)="onElementSelect()"
      (onSelectAll)="onElementSelect()"
      (onDeSelectAll)="onElementSelect()"
      (onFilterSelectAll)="onElementSelect()"
      (onFilterDeSelectAll)="onElementSelect()">
  </angular2-multiselect>
</div>